import Tables from 'src/class/Tables';
import i18n from "src/i18n";

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      minWidth: 150,
      sortable: true,
      show: false,
    },
    {
      prop: 'farm_name',
      label: i18n.t('common_words.farm'),
      minWidth: 170,
      sortable: true,
      fixed: true,
    },
    {
      prop: 'worker',
      label: i18n.t('labor.worker'),
      minWidth: 250,
      sortable: true,
      fixed: true,
    },
    {
      prop: 'user_name',
      label: i18n.t('common_words.user'),
      minWidth: 170,
      sortable: true,
      fixed: true,
    },
    {
      prop: 'lot_name',
      label: i18n.t('common_words.allotment'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'date_save',
      label: i18n.t('common_words.save_date'),
      minWidth: 170,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'week_save',
      label: i18n.t('common_words.week'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'day_save',
      label: i18n.t('common_words.day'),
      minWidth: 120,
      show: false,
    },
    {
      prop: 'observations',
      label: i18n.t('common_words.observation'),
      minWidth: 250,
    },
  ];

  const TableDetails = { ...Tables.Table };
  TableDetails.tableColumns = [
    {
      prop: 'latitude',
      label: i18n.t('common_words.latitude'),
      minWidth: 110,
      show: false,
    },
    {
      prop: 'longitude',
      label: i18n.t('common_words.longitude'),
      minWidth: 110,
      show: false,
    },
    {
      prop: 'altitude',
      label: i18n.t('common_words.altitude'),
      minWidth: 110,
      show: false,
    },
    {
      prop: 'audit_task_with_trashed.name',
      label: i18n.t('common_words.detail'),
      minWidth: 200,
    },
    {
      prop: 'audit_task_with_trashed.calification_type',
      label: i18n.t('common_words.type_of_grade'),
      minWidth: 180,
      show: false,
    },
  ];

  const SearchDetails = {
    pagedDataDetails() {
      return this.tableDataDetails.slice(this.fromDetails, this.toDetails);
    },

    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedDataDetails() {
      let result = this.tableDataDetails;
      if (this.searchQueryDetails !== '') {
        result = this.fuseSearchDetails.search(
          '=' + this.searchQueryDetails + ''
        );
      }

      this.paginationDetails.total = result.length;

      return result.slice(this.fromDetails, this.toDetails);
    },

    toDetails() {
      let highBound = this.fromDetails + this.paginationDetails.perPage;
      if (this.totalDetails < highBound) {
        highBound = this.totalDetails;
      }

      return highBound;
    },

    fromDetails() {
      return (
        this.paginationDetails.perPage *
        (this.paginationDetails.currentPage - 1)
      );
    },

    totalDetails() {
      return this.paginationDetails.totalDetails;
    },
  };

  return { Table, SearchDetails, TableDetails };
};

export default configTable;